<template>
    <v-card class="pa-3 ma-md-3">
        <v-toolbar flat color="#1d2735" dark>
            <v-icon class="white--text" style="font-size: 45px"
                >mdi-account-supervisor-circle</v-icon
            >
            <pre><v-toolbar-title><h2>Lista de planificaciones de obras</h2></v-toolbar-title></pre>
        </v-toolbar>
        <v-tooltip right v-if="rol != 6 && rol != 7">
            <template v-slot:activator="{ on, attrs }">
                <v-btn
                    fab
                    :to="{ path: `/guardar-plan-orden` }"
                    :loading="isloading"
                    :disabled="isloading"
                    color="success"
                    class="mt-2 mr-2"
                    v-bind="attrs"
                    v-on="on"
                >
                    <v-icon class="white--text">mdi-plus</v-icon>
                </v-btn>
            </template>
            <span>Nuevo plan</span>
        </v-tooltip>
        <v-tooltip right>
            <template v-slot:activator="{ on, attrs }">
                <v-btn
                    fab
                    :to="{ path: `/calendario-plan-orden` }"
                    :loading="isloading"
                    :disabled="isloading"
                    color="primary darken-1"
                    class="mt-2 mr-2"
                    v-bind="attrs"
                    v-on="on"
                >
                    <v-icon class="white--text">mdi-calendar</v-icon>
                </v-btn>
            </template>
            <span>Calendario de obras</span>
        </v-tooltip>
        <v-tooltip right>
            <template v-slot:activator="{ on, attrs }">
                <v-btn
                    fab
                    @click="openFormOrdenFichaje(null)"
                    :loading="isloading"
                    :disabled="isloading"
                    color="warning"
                    class="mt-2"
                    v-bind="attrs"
                    v-on="on"
                >
                    <v-icon class="white--text">mdi-plus</v-icon>
                </v-btn>
            </template>
            <span>Nuevo fichaje</span>
        </v-tooltip>
        <v-row>
            <v-col cols="11" md="4">
                <v-text-field
                    prepend-icon="mdi-account-search"
                    v-model="search"
                    label="Buscar"
                ></v-text-field>
            </v-col>
        </v-row>

        <v-data-table
            :item-class="getRowClass"
            dense
            :headers="headers"
            :items="ordenes"
            :search="search"
            :items-per-page="15"
            item-key="id"
            class="elevation-1"
            :sort-by="['nombre']"
            :sort-desc="[false]"
            @click:row="goToOrden"
        >
            <template v-slot:item.timer="{ item }">
                <template v-if="item.orden_trabajo != null">
                    <template
                        v-if="
                            item.orden_trabajo.fichajes != null &&
                            item.id_estado != 4
                        "
                    >
                        <div
                            v-if="item.orden_trabajo.fichajes.length % 2 == 0"
                            @click.stop="Fichar(item.orden_trabajo, false)"
                            class="round"
                            style="background-color: green"
                        >
                            <v-icon class="white--text">mdi-play</v-icon>
                        </div>
                        <div style="display: flex" v-else>
                            <div
                                @click.stop="Fichar(item.orden_trabajo, false)"
                                class="round"
                                style="background-color: orange"
                            >
                                <v-icon class="white--text">mdi-pause</v-icon>
                            </div>
                            <div
                                @click.stop="Fichar(item.orden_trabajo, true)"
                                class="round"
                                style="background-color: red"
                            >
                                <v-icon class="white--text">mdi-stop</v-icon>
                            </div>
                        </div>
                    </template>
                </template>
            </template>
            <template v-slot:item.fecha="{ item }">
                <span>{{ item.fecha | format_date }}</span>
            </template>
            <template v-slot:item.action="{ item }">
                <a @click.stop="openModal(item)" v-if="rol != 6 && rol != 7">
                    <v-icon
                        @click="openModal(item)"
                        small
                        class="mr-2"
                        color="red"
                        style="font-size: 25px"
                        title="BORRAR"
                        >mdi-trash-can</v-icon
                    >
                </a>

                <v-tooltip top v-if="rol != 7">
                    <template v-slot:activator="{ on, attrs }">
                        <v-icon
                            @click.stop="openFormOrdenFichaje(item)"
                            v-bind="attrs"
                            v-on="on"
                        >
                            mdi-checkbox-marked-circle-outline
                        </v-icon>
                    </template>
                    <span>Fichar</span>
                </v-tooltip>
            </template>
        </v-data-table>

        <!-- Dialog para eliminar plan -->
        <v-dialog v-model="dialog" max-width="500px">
            <v-card>
                <v-card-title
                    class="text-h5 aviso"
                    style="
                        justify-content: center;
                        background: #1d2735;
                        color: white;
                    "
                >
                    Aviso
                </v-card-title>
                <v-card-text style="text-align: center">
                    <h2>¿Estás seguro que deseas eliminar?</h2>
                </v-card-text>
                <v-card-actions class="pt-3">
                    <v-spacer></v-spacer>
                    <v-btn
                        color="error"
                        large
                        @click="
                            dialog = false;
                            selectedItem = {};
                        "
                        >Cancelar</v-btn
                    >
                    <v-btn color="success" large @click="deleteUser()"
                        >Confirmar</v-btn
                    >
                    <v-spacer></v-spacer>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!-- Dialog para seleccionar orden -->
        <v-dialog v-model="isMultipleOrden" max-width="500px">
            <v-card>
                <v-card-title
                    class="text-h5 aviso"
                    style="
                        justify-content: center;
                        background: #1d2735;
                        color: white;
                    "
                >
                    Selecciona la obra que quieres revisar</v-card-title
                >
                <v-card-text>
                    <div class="d-flex flex-wrap gap-3 mt-3 justify-center">
                        <router-link
                            class="mr-1"
                            v-for="orden in selectedPlanOrden.ordenes_trabajo"
                            :key="orden.id_orden"
                            :to="`/guardar-orden?id=${orden.id_orden}`"
                        >
                            <v-chip color="primary" link outlined>
                                {{ orden.nro_orden }}
                            </v-chip>
                        </router-link>
                    </div>
                </v-card-text>
                <v-card-actions class="d-flex justify-center">
                    <v-btn color="error" @click="isMultipleOrden = false"
                        >Cancelar</v-btn
                    >
                </v-card-actions>
            </v-card>
        </v-dialog>

        <FormOrdenFichaje
            v-model="isNewFichajeVisible"
            :item="selectedFichaje"
            @refresh="getordenes"
        ></FormOrdenFichaje>
    </v-card>
</template>
<script>
import FormOrdenFichaje from "../../ordenesTrabajo/componentes/FormOrdenFichaje.vue";
export default {
    components: {
        FormOrdenFichaje,
    },
    data() {
        return {
            search: "",
            userId: null,
            ordenes: [],
            selectedItem: 0,
            dialog: false,
            isNewFichajeVisible: false,
            isMultipleOrden: false,
            selectedPlanOrden: {},
            selectedFichaje: {
                id: null,
                usuario_id: null,
                orden_id: null,
                fecha: "",
                hora_inicio: "",
                hora_fin: "",
            },
        };
    },
    created() {
        this.userId = localStorage.getItem("user_id");
        this.getordenes();
    },
    methods: {
        Fichar(item, detener) {
            axios
                .post(`api/fichar-orden/${item.id}`, {
                    detener: detener,
                })
                .then(
                    (res) => {
                        item.fichajes = res.data.ordenes;
                        item.horas_realizadas = res.data.horas;
                        item.id_estado = res.data.estado;
                    },
                    (res) => {}
                );
        },
        getRowClass(item) {
            return "pointer";
        },
        getordenes() {
            axios.get(`api/get-planes-orden`).then(
                (res) => {
                    this.ordenes = res.data.data;
                    this.clearFormFichaje();
                },
                (err) => {
                    this.$custom_error("Error consultando las obras");
                }
            );
        },
        openModal(item) {
            this.selectedItem = this.ordenes.indexOf(item);
            this.dialog = true;
        },
        deleteUser() {
            axios
                .post("api/cancel-plan-orden", {
                    id: this.ordenes[this.selectedItem].id,
                })
                .then(
                    (res) => {
                        this.$toast.sucs("Plan eliminado con éxito");
                        this.dialog = false;
                        this.getordenes();
                    },
                    (err) => {
                        this.$custom_error("Error eliminando el plan");
                    }
                );
        },
        goToOrden(item) {
            if (
                item.ordenes_ids.length > 1 &&
                (this.rol == 6 || this.rol == 7)
            ) {
                this.selectedPlanOrden = item;
                this.isMultipleOrden = true;
            } else {
                const id_orden = item.ordenes_ids[0];
                this.$router.push(
                    this.rol != 6 && this.rol != 7
                        ? `/guardar-plan-orden?id=${item.id}&tab=2`
                        : `/guardar-orden?id=${id_orden}`
                );
            }
        },

        openFormOrdenFichaje(item) {
            if (item != null) {
                if (item.usuario_id == null) {
                    this.selectedFichaje.usuario_id = parseInt(this.userId);
                }

                this.selectedFichaje.fecha = item.fecha;

                this.ordenes_trabajo = item.ordenes_trabajo;
                if (item?.ordenes_ids?.length == 1) {
                    this.selectedFichaje.orden_id = item.ordenes_ids[0];
                    this.selectedFichaje.orden = {
                        id: item.ordenes_trabajo[0].id_orden,
                        nro_orden: item.ordenes_trabajo[0].nro_orden,
                    };
                }
            } else {
                this.clearFormFichaje();
            }

            this.isNewFichajeVisible = true;
        },
        clearFormFichaje() {
            this.selectedFichaje = {
                id: null,
                usuario_id: null,
                orden_id: null,
                fecha: "",
                hora_inicio: "",
                hora_fin: "",
            };
        },
    },
    computed: {
        isloading: function () {
            // return this.$store.getters.getloading
        },
        rol: function () {
            const role = parseInt(localStorage.getItem("role"));
            return role;
        },
        headers() {
            let headers = [
                {
                    text: "Obras",
                    value: "ordenes",
                    sortable: false,
                },
                { text: "Equipo", value: "equipo", sortable: false },
                {
                    text: "Observaciones",
                    value: "observacion",
                    sortable: false,
                },
                { text: "Fecha", value: "fecha", sortable: false },
                // { text: "Audio", value: "timer", sortable: false },
            ];
            if (this.rol != 7) {
                headers.push({
                    text: "Acciones",
                    value: "action",
                    sortable: false,
                });
            }
            return headers;
        },
    },
};
</script>
